import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

type ReturnItemListSchema = {
  reject_id: number
  trx_code: string
}

export const useGetDropdownReturnItem = () => {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
  
    api.get("/proreject/list_reject_trx_code")
    .then((res: SuccessFetch<{ payload: ReturnItemListSchema[] }>) => {
      setData(res.data.payload.map(item => ({
        label: item.trx_code,
        value: item.reject_id.toString()
      })));
    })
    .catch(() => setData([]) )
    .finally(() => setLoading(false))
  
    return () => {
      setData([])
      setLoading(true)
    }
    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}